module.exports = __webpack_public_path__ + "img/04.d1cd55b4.png";